var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIncolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 8.1685L9.91681 15.7518C9.45268 16.216 9.19193 16.8455 9.19193 17.5018C9.19193 18.1582 9.45268 18.7877 9.91681 19.2518C10.3809 19.716 11.0104 19.9767 11.6668 19.9767C12.3232 19.9767 12.9527 19.716 13.4168 19.2518L21.0001 11.6685C21.9284 10.7402 22.4499 9.48125 22.4499 8.1685C22.4499 6.85574 21.9284 5.59676 21.0001 4.6685C20.0719 3.74024 18.8129 3.21875 17.5001 3.21875C16.1874 3.21875 14.9284 3.74024 14.0001 4.6685L6.41681 12.2518C5.02442 13.6442 4.24219 15.5327 4.24219 17.5018C4.24219 19.471 5.02442 21.3594 6.41681 22.7518C7.8092 24.1442 9.69768 24.9265 11.6668 24.9265C13.6359 24.9265 15.5244 24.1442 16.9168 22.7518L24.5001 15.1685",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIncolor);
export default __webpack_public_path__ + "static/media/fileIncolor.3bdaf85c34682066aa6da4a519451ef9.svg";
export { ForwardRef as ReactComponent };